// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fEnn","colBig":"styles_colBig__3zsmn","colSmall":"styles_colSmall__2gBCT","shopifyNameWrapper":"styles_shopifyNameWrapper__ti7HX"};